import { 
  PricingInputBoundary, 
  GetPricingRequest,
  PricingOutputBoundary, 
  PricingResponse,
  PricingRepository,
  PricingConfiguration
} from '../types/PricingTypes';


export class GetPricingInteractor implements PricingInputBoundary {
  constructor(
    private readonly pricingRepository: PricingRepository,
    private readonly outputBoundary: PricingOutputBoundary
  ) {}


  public async getPricingConfiguration(request: GetPricingRequest): Promise<void> {
    try {
      const configuration = await this.pricingRepository.getPricingConfiguration();
      
      // Apply filtering business logic
      let filteredConfiguration = configuration;
      
      if (request.filterByFeature) {
        const filteredTiers = configuration.tiers.filter(tier => 
          tier.hasFeature(request.filterByFeature!)
        );
        filteredConfiguration = new PricingConfiguration(
          filteredTiers,
          configuration.allAvailableFeatures
        );
      }


      const response: PricingResponse = {
        configuration: filteredConfiguration,
        requestedAt: new Date()
      };


      this.outputBoundary.presentPricingConfiguration(response);
    } catch (error) {
      this.outputBoundary.presentPricingError(
        error instanceof Error ? error.message : 'Unknown error occurred'
      );
    }
  }
}


